import React from "react";
import CourseHeader from "../Shared/CourseHeader";

const AccountancyHeader = () => {
  return (
    <CourseHeader
      title=""
      highlight="Accountancy"
      subtitle="Count. Analyze. Excel."
      backgroundImage="https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=2072&q=80"
    />
  );
};

export default AccountancyHeader;
